export function validarCedula(cedula: string): boolean {
  if (!/^\d{10}$/.test(cedula)) return false; // Solo 10 dígitos

  const provincia = parseInt(cedula.substring(0, 2), 10);
  const tercerDigito = parseInt(cedula.charAt(2), 10);

  if (provincia < 1 || provincia > 24 || tercerDigito >= 6) return false;

  const coeficientes = [2, 1, 2, 1, 2, 1, 2, 1, 2];
  const verificador = parseInt(cedula.charAt(9), 10);

  let suma = 0;

  for (let i = 0; i < 9; i++) {
    let valor = parseInt(cedula.charAt(i), 10) * coeficientes[i];
    if (valor > 9) valor -= 9;
    suma += valor;
  }

  const digitoCalculado = (10 - (suma % 10)) % 10;

  return digitoCalculado === verificador;
}
